import React, { ErrorInfo } from 'react';

interface IErrorBoundaryProps {
    children: React.ReactElement
}

interface IErrorBoundaryState {
    errorOcсured: boolean,
    errorInfo: {
        componentStack: string | null
    },
    errorMessage: string
}

class ErrorBoundary extends React.Component<IErrorBoundaryProps, IErrorBoundaryState> {

    constructor(props: IErrorBoundaryProps) {
        super(props);
        this.state = {
            errorOcсured: false,
            errorInfo: {
                componentStack: null
            },
            errorMessage: ""
        }
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        this.setState({
            errorOcсured: true,
            errorInfo: errorInfo,
            errorMessage: error.toString()
        })
    }   

    render() {
        if(this.state.errorOcсured) {
            return (
                <>
                    <div className="my-2">
                        <h1>Oops some error occured please let us know about it</h1>
                        <h2>Refresh page and try again.</h2>
                    </div>

                    <p>Info: {this.state?.errorMessage}</p>
                </>
            )
        }

        return this.props.children;
    }

}

export default ErrorBoundary;